import {
    FetchInfo,
    ServerFetchState,
    useServerErrorEffect,
    useServerFetch as useSharedServerFetch,
} from 'dg-web-shared/lib/hooks/ServerStateHooks';
import { useNavigate } from 'react-router';
import { AuthStatusType, useAuthState } from '../app/state/AuthState';
import { clear } from 'dg-web-shared/lib/LocalStorage';
import { setAppToken } from '../Native';

export type { FetchInfo, ServerFetchState };

export function useServerFetch<Data, Context extends object, ErrorData = Data>(
    requestInfoFactory: FetchInfo<Context>,
    context: Context | null,
): ServerFetchState<Data, ErrorData> {
    const result = useSharedServerFetch<Data, Context, ErrorData>(
        requestInfoFactory,
        context,
    );
    const { authStatus, setAuthStatus } = useAuthState();
    const navigate = useNavigate();

    useServerErrorEffect(result[0], statusCode => {
        if (statusCode === 408) {
            navigate('/offline');
        } else if (
            (statusCode === 401 || statusCode === 403) &&
            authStatus === AuthStatusType.OK
        ) {
            clear();
            setAppToken(null);
            setAuthStatus(AuthStatusType.NOT_OK);
            navigate('/unauthorized');
        }
    });

    return result;
}
